export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.client) {
    const router = useRouter();
    const storeUser = userStore();
    if (!storeUser.isLoggedIn || !storeUser.user) {
      return router.push({
        name: "language-login",
        params: { language: router.currentRoute.value.params.language },
        query: to.query,
      });
    }
  }
});
